<script>
const op = [
  // {
  //   name: "总部",
  //   val: 0
  // },
  // {
  //   name: "家得福·鼓楼店",
  //   val: 1
  // },
  // {
  //   name: "家得福·奥体店",
  //   val: 2
  // },
  // {
  //   name: "家得福·海云店",
  //   val: 3
  // },
  // {
  //   name: "家得福·大中华酒店",
  //   val: 4
  // },
  // {
  //   name: "家得福·南方时代广场店",
  //   val: 5
  // },
  // {
  //   name: "家得福金陵宴·新街口店",
  //   val: 6
  // },
  // {
  //   name: "家得福·徐悲鸿画苑",
  //   val: 7
  // }
];
const notifyType = [
  {
    name: "通知公告",
    val: 1
  },
  {
    name: "个人消息",
    val: 2
  },
  {
    name: "考试资讯",
    val: 3
  },
  {
    name: "新闻资讯",
    val: 4
  },
  {
    name: "企业文化",
    val: 5
  }
];
const opt = [
  {
    name: "容易",
    val: 1
  },
  {
    name: "一般",
    val: 2
  },
  {
    name: "较难",
    val: 3
  }
];
const options = [
  {
    name: "创建中",
    val: 0
  },
  {
    name: "待审批",
    val: 1
  },
  {
    name: "审批通过",
    val: 2
  },
  {
    name: "下架",
    val: 3
  }
];
const typeObj = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未付款",
    val: "0"
  },
  {
    name: "已付款",
    val: "1"
  }
];
const typeObjs = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "待审核",
    val: 1
  },
  {
    name: "审核通过",
    val: 2
  },
  {
    name: "审核不通过",
    val: 3
  }
];
const cities = [
  {
    name: "私募课程",
    val: 1
  },
  {
    name: "免费课程",
    val: 0
  }
];
const courseTags = [
  {
    name: "普通课程",
    val: 1
  },
  {
    name: "精品课程",
    val: 2
  },
  {
    name: "推荐课程",
    val: 3
  }
];
const opts = [
  {
    name: "视频文件",
    val: 0
  },
  {
    name: "其他文件",
    val: 1
  }
];
const status = [
  {
    name: "禁用",
    val: 0
  },
  {
    name: "启用",
    val: 1
  }
];
// const notifyType = [
//   {
//     name: "通知",
//     val: 1
//   },
//   {
//     name: "消息",
//     val: 2
//   }
// ];
const tys = [
  {
    name: "已清空",
    val: 0
  },
  {
    name: "消息",
    val: 1
  },
  {
    name: "警告",
    val: 2
  },
  {
    name: "次要",
    val: 3
  },
  {
    name: "主要",
    val: 4
  },
  {
    name: "紧急",
    val: 5
  },
  {
    name: "全部",
    val: ""
  }
];
const ty = [
  {
    name: "已清除",
    val: 0
  },
  {
    name: "未解决",
    val: 1
  }
];
const typ = [
  {
    value: 1,
    label: "维护"
  },
  {
    value: 2,
    label: "维修"
  }
];
const types = [
  {
    value: 1,
    label: "未派发"
  },
  {
    value: 2,
    label: "已派发"
  },
  {
    value: 3,
    label: "已完成"
  }
];
const tyop = [
  {
    name: "判断题",
    val: 1
  },
  {
    name: "单选题",
    val: 2
  },
  {
    name: "多选题",
    val: 3
  },
  {
    name: "填空题",
    val: 4
  }
];
const abc = [
  {
    name: "自动颁发证书",
    val: 1
  },
  {
    name: "手动颁发证书",
    val: 2
  }
];
const ab = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未开始",
    val: "0"
  },
  {
    name: "进行中",
    val: "1"
  },
  {
    name: "已结束",
    val: "2"
  }
];
const abd = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未开始",
    val: 1
  },
  {
    name: "进行中",
    val: 2
  },
  {
    name: "已结束",
    val: 3
  }
];
const ac = [
  {
    name: "单选题",
    val: 1
  },
  {
    name: "多选题",
    val: 2
  },
  {
    name: "判断题",
    val: 3
  },

  {
    name: "填空题",
    val: 4
  },
  {
    name: "问答题",
    val: 5
  }
];
const ol = [
  {
    name: "公开试题",
    val: 1
  },
  {
    name: "考试专用试题",
    val: 2
  }
];
const statusyupe = [
  {
    name: "未开始",
    val: 1
  },
  {
    name: "进行中",
    val: 2
  },
  {
    name: "已结束",
    val: 3
  }
];
const pin = [
  {
    name: "整页显示题目",
    val: 1
  },
  {
    name: "单题显示",
    val: 2
  }
];
const switchs = [
  {
    name: "不允许切换屏幕",
    val: 2
  },
  {
    name: "允许切换屏幕",
    val: 1
  }
];
const tryorder = [
  {
    name: "随机顺序",
    val: 2
  },
  {
    name: "原始顺序",
    val: 1
  }
];

const slideshowmodel = [
  {
    name: "移动端",
    val: 2
  },
  {
    name: "PC端",
    val: 1
  }
];

const sexop = [
  {
    name: "女",
    val: 2
  },
  {
    name: "男",
    val: 1
  }
];

export default {
  op, //用户地址
  opt,
  options,
  typeObj,
  typeObjs,
  cities,
  courseTags,
  opts,
  tys,
  ty,
  typ,
  types,
  tyop,
  abc,
  ab,
  ac,
  ol,
  statusyupe,
  pin,
  switchs,
  tryorder,
  slideshowmodel,
  sexop,
  status,
  notifyType,
  abd
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue